import React from "react";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import Image from "../assets/Doctor-Frame.png";
import Madanmohanmalviya from '../assets/doctors/Madanmohanmalviya.jpg'
import DrAnnie from '../assets/doctors/DrAnnie.jpg'

const VisionAndMission = () => {
    return (
        <div className="text-gray-800 bg-white">
            <Navbar />

            {/* Hero Section with Overlay Text */}
            <div className="relative">
                <div
                    className="h-96 bg-cover bg-center"
                    style={{ backgroundImage: `url(${Image})` }}
                    role="img"
                    aria-label="Doctor Frame"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent flex items-center">
                    <div className="max-w-screen-xl mx-auto px-6 w-full">
                        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                            Our Vision & Mission
                        </h1>
                        <p className="text-white/90 text-lg max-w-2xl">
                            Guided by the principles of our founders, we strive for excellence in trauma care,
                            education, and research with unwavering commitment to humanity.
                        </p>
                    </div>
                </div>
            </div>

            {/* Content Section */}
            <main className="max-w-screen-xl px-4 py-16 mx-auto">
                {/* Vision & Mission Cards */}
                <div className="grid gap-8 md:grid-cols-2 mb-16">
                    {/* Vision Card */}
                    <div className="bg-gradient-to-br from-[#009DA5]/10 to-white rounded-2xl shadow-lg overflow-hidden transition-all hover:shadow-xl">
                        <div className="h-2 bg-[#009DA5]"></div>
                        <div className="p-8">
                            <div className="inline-block p-3 rounded-full bg-[#009DA5]/10 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#009DA5]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                            </div>
                            <h3 className="text-3xl font-bold mb-4">
                                Our <span className="text-[#009DA5]">Vision</span>
                            </h3>
                            <p className="text-gray-700 leading-relaxed">
                                To become a centre of excellence in trauma care, medical education, and research, driven by compassion, innovation, and a commitment to humanity. The Trauma Centre aspires to serve as a beacon of hope and healing for Purvanchal and beyond, upholding the values envisioned by Pandit Madan Mohan Malaviya and Dr. Annie Besant
                            </p>
                        </div>
                    </div>

                    {/* Mission Card */}
                    <div className="bg-gradient-to-br from-[#009DA5]/10 to-white rounded-2xl shadow-lg overflow-hidden transition-all hover:shadow-xl">
                        <div className="h-2 bg-[#009DA5]"></div>
                        <div className="p-8">
                            <div className="inline-block p-3 rounded-full bg-[#009DA5]/10 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#009DA5]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                </svg>
                            </div>
                            <h3 className="text-3xl font-bold mb-4">
                                Our <span className="text-[#009DA5]">Mission</span>
                            </h3>
                            <ul className="space-y-3 text-gray-700">
                                {[
                                    "To provide comprehensive and compassionate trauma care through a multidisciplinary approach.",
                                    "To foster academic excellence by training healthcare professionals with the latest advancements in trauma management.",
                                    "To promote research and innovation to continuously enhance trauma care practices.",
                                    "To engage the community through awareness programs on trauma prevention and safety measures.",
                                    "To collaborate nationally and internationally for knowledge exchange and skill enhancement.",
                                    "To uphold the rich legacy of Banaras Hindu University by blending traditional values with modern medical practices."
                                ].map((item, idx) => (
                                    <li key={idx} className="flex items-start">
                                        <span className="mr-2 mt-1 text-[#009DA5]">•</span>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Inspired by Visionaries */}
                <section className="mb-16">
                    <div className="text-center mb-12">
                        <h2 className="inline-block text-3xl font-bold relative pb-2 mb-4">
                            Inspired by <span className="text-[#009DA5]">Visionaries</span>
                            <span className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-[#009DA5] to-transparent"></span>
                        </h2>
                        <p className="text-gray-600 max-w-2xl mx-auto">
                            Our core values and mission are deeply rooted in the philosophies of our founding visionaries
                        </p>
                    </div>

                    <div className="flex flex-col md:flex-row items-stretch md:items-start md:space-x-6">
                        {/* Card 1 */}
                        <div className="flex-1 bg-white rounded-xl shadow-md overflow-hidden transition-all hover:shadow-lg flex flex-col md:flex-row mb-6 md:mb-0">
                            <img
                            src={Madanmohanmalviya}
                            alt="Pandit Madan Mohan Malaviya"
                            className="w-full md:w-1/3 h-48 md:h-auto object-cover"
                            />
                            <div className="p-6 border-l-4 border-[#009DA5] flex-1">
                            <h3 className="text-xl font-bold mb-3">Pandit Madan Mohan Malaviya</h3>
                            <p className="text-gray-700">
                                Malaviya Ji envisioned Banaras Hindu University as a place where education and service to humanity go hand in hand. Guided by his ideal of <em>"Service before Self"</em>, the Trauma Centre is committed to selfless care, dedication, and community service, empowering society through quality healthcare and education.
                            </p>
                            </div>
                        </div>

                        {/* Vertical Divider */}
                        <div className="hidden md:flex w-px bg-gray-300" />

                        {/* Card 2 */}
                        <div className="flex-1 bg-white rounded-xl shadow-md overflow-hidden transition-all hover:shadow-lg flex flex-col md:flex-row">
                            <img
                            src={DrAnnie}
                            alt="Dr. Annie Besant"
                            className="w-full md:w-1/3 h-48 md:h-auto object-cover"
                            />
                            <div className="p-6 border-l-4 border-[#009DA5] flex-1">
                            <h3 className="text-xl font-bold mb-3">Dr. Annie Besant</h3>
                            <p className="text-gray-700">
                                A staunch advocate of humanitarian service and moral responsibility, Dr. Besant believed in uplifting society through education and compassionate care. The Trauma Centre embodies her vision by promoting holistic healing, public health awareness, and outreach programs to benefit the community.
                            </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Core Values */}
                <section className="rounded-2xl overflow-hidden shadow-lg bg-gradient-to-br from-[#F6FCFD] to-white">
                    <div className="p-8 md:p-12">
                        <div className="text-center mb-12">
                            <div className="inline-block p-3 rounded-full bg-[#009DA5]/10 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#009DA5]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                </svg>
                            </div>
                            <h2 className="text-3xl font-bold mb-4">
                                Our <span className="text-[#009DA5]">Core Values</span>
                            </h2>
                            <p className="text-gray-600 max-w-2xl mx-auto">
                                We, the members of the Trauma Center IMS BHU, hold the following values to be the foundation of our identity. We shall endeavour to think and act at all times in accordance with these values.
                            </p>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                            {[
                                {
                                    title: "Patient Centric",
                                    desc: "We put the needs of the patient first in all our actions.",
                                    icon: (
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                        </svg>
                                    )
                                },
                                {
                                    title: "Committed to Deliver",
                                    desc: "We give our best in all that we undertake and are committed to deliver on time.",
                                    icon: (
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    )
                                },
                                {
                                    title: "Humbleness",
                                    desc: "We remain modest and humble in our achievements. Our work speaks for itself.",
                                    icon: (
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    )
                                },
                                {
                                    title: "Value-Driven",
                                    desc: "We seek value and maximize our gains by using our resources judiciously.",
                                    icon: (
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    )
                                }
                            ].map((value, idx) => (
                                <div key={idx} className="bg-white p-6 rounded-xl shadow-sm flex flex-col items-center text-center hover:shadow-md transition-shadow">
                                    <div className="p-3 rounded-full bg-[#009DA5]/10 text-[#009DA5] mb-4">
                                        {value.icon}
                                    </div>
                                    <h4 className="text-lg font-bold mb-2">{value.title}</h4>
                                    <p className="text-gray-600">{value.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default VisionAndMission;